import dynamic from "next/dynamic";
import { OrganizationJsonLd } from "next-seo";

import type { ISiteSettingsBlok } from "@/bloks/SiteSettings/SiteSettings";
import Footer from "@/components/Layout/Footer";
import { SITE_ORIGIN } from "@/features/i18n/i18n.config.mjs";
import type { ICart } from "@/types/centra";

import MobileTag from "../MobileTag";
import NewsletterSignup from "../NewsletterSignup";
import AnnouncementBar from "./AnnouncementBar";
import Header from "./Header";
import styles from "./layout.module.scss";
import PreviewBanner from "./PreviewBanner/PreviewBanner";
const DynamicCart = dynamic(() => import("@/components/Cart"));
type Props = {
  children?: React.ReactNode;
  cart: ICart;
  cookie: string | null;
  siteSettings?: ISiteSettingsBlok | null;
};

const UI: React.FC<Props> = ({ children, cart, cookie, siteSettings }) => {
  const orgUrl = SITE_ORIGIN;

  const sameAs = siteSettings?.sameAs
    ?.map((entry) => entry?.link?.url || entry?.link?.cached_url)
    .filter((url): url is string => Boolean(url));

  const address = siteSettings?.streetAddress
    ? {
        streetAddress: siteSettings.streetAddress,
        addressLocality: siteSettings.addressLocality ?? "",
        postalCode: siteSettings.postalCode ?? "",
        addressCountry: siteSettings.addressCountry ?? "",
      }
    : undefined;

  const contactPoint = siteSettings?.phone
    ? [
        {
          contactType: "customer service",
          telephone: siteSettings.phone,
          email: siteSettings.email,
        },
      ]
    : undefined;

  return (
    <>
      {siteSettings?.organizationName && (
        <OrganizationJsonLd
          type="Organization"
          name={siteSettings.organizationName}
          url={orgUrl}
          logo={siteSettings.logo?.filename}
          sameAs={sameAs}
          address={address}
          contactPoint={contactPoint}
        />
      )}
      <PreviewBanner />
      <AnnouncementBar />
      {/* <Snackbar /> there is no snackbar in design */}
      {cookie && <></> /*Popup newsletter modal*/}
      <NewsletterSignup />
      <Header />
      <MobileTag />
      {cart.shouldRender && <DynamicCart />}
      <div id="site-content" className={`site-content ${styles.wrapper}`}>
        {children}
      </div>
      <Footer />
    </>
  );
};

export default UI;
